import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "input-label mb-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-error mr-4" }, "*", -1)
const _hoisted_3 = { class: "error-message" }

import { useField, useFieldArray } from 'vee-validate';
import Search from './components/Search.vue';
import MedicationItem from './components/MedicationItem.vue';
import TooltipButton from '../TooltipButton.vue';


export default {
  __name: 'MedicationChoose',
  setup(__props) {

const { errors, errorMessage } = useField('selectedMedications');

const { remove, fields, push } = useFieldArray('selectedMedications');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(" Wnioskowanie o lek (do 1 pozycji) "),
      _hoisted_2,
      _createVNode(TooltipButton, null, {
        default: _withCtx(() => [
          _createTextVNode(" ? ")
        ]),
        tooltip: _withCtx(() => [
          _createTextVNode("Zgodnie z obowiązującym regulaminem można wnioskować wyłącznie o 1 lek w ramach 1 recepty.")
        ]),
        _: 1
      })
    ]),
    _createVNode(Search, {
      onAddItem: _unref(push),
      hasErrors: !!_unref(errors).length,
      selectedMedications: _unref(fields)
    }, null, 8, ["onAddItem", "hasErrors", "selectedMedications"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), (field, idx) => {
      return (_openBlock(), _createBlock(MedicationItem, {
        id: idx,
        field: field.value,
        key: field.key,
        onRemoveItem: _unref(remove)
      }, null, 8, ["id", "field", "onRemoveItem"]))
    }), 128)),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(errorMessage)), 1)
  ], 64))
}
}

}